import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MapView from './components/MapView';
import MenuView from './components/MenuView';
import CartView from './components/CartView';
import OrderStatusView from './components/OrderStatusView';
import OrderHistoryView from './components/OrderHistoryView';
import OffertaView from './components/OffertaView';
import { CartProvider } from './context/CartContext';
import { PromoProvider } from './context/PromoContext';
import { NotificationProvider } from './context/NotificationContext';
import { AuthProvider } from './context/AuthContext';
import PlatformAuth from './components/PlatformAuth';
import ProfileView from './components/ProfileView';
import SupportRequestFab from './features/support/SupportRequestFab';
// import TokenRefreshDebug from './components/TokenRefreshDebug';
import './App.css';
import './styles/animations.css';
import './styles/mobile.css';

function OffertaPage() {
  return (
    <div className="app">
      <OffertaView />
    </div>
  );
}

function AppShell() {
  return (
    <CartProvider>
      <PromoProvider>
        <NotificationProvider>
          <div className="app">
            <SupportRequestFab />
            <Routes>
              <Route index element={<MapView />} />
              <Route path="menu/:cafeId" element={<MenuView />} />
              <Route path="cart" element={<CartView />} />
              <Route path="order/:orderId" element={<OrderStatusView />} />
              <Route path="orders" element={<OrderHistoryView />} />
              <Route path="profile" element={<ProfileView />} />
            </Routes>
            {/* Uncomment the line below to enable token refresh debugging */}
            {/* <TokenRefreshDebug /> */}
          </div>
        </NotificationProvider>
      </PromoProvider>
    </CartProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/offerta" element={<OffertaPage />} />
          <Route path="/offerta/:shopId" element={<OffertaPage />} />
          <Route
            path="*"
            element={
              <PlatformAuth>
                <AppShell />
              </PlatformAuth>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
